import { useState } from "react";

const useEmailValidation = () => {
  const [email, setEmail] = useState("");
  const [emailError, setError] = useState("");

  const validateEmail = (value) => {
    setEmail(value);
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      setError("Email is required.");
    } else if (!emailPattern.test(value)) {
      setError("Invalid email format.");
    } else {
      setError("");
    }
  };

  return {
    email,
    emailError,
    setEmail: validateEmail,
  };
};

export default useEmailValidation;
